import { render, staticRenderFns } from "./ViewLoadingMessage.vue?vue&type=template&id=1ffbd61b&"
import script from "./ViewLoadingMessage.vue?vue&type=script&lang=js&"
export * from "./ViewLoadingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports